import React from 'react'

const NotificationConfig = () => {
  return (
    <div>NotificationConfig</div>
  )
}

export default NotificationConfig